import { createAction, props } from '@ngrx/store';
import { SupplierOtherCreditor } from '@feature/suppliers/models/supplier-other-creditor';

export const load = createAction('[Supplier Other Creditor] Load');
export const loadComplete = createAction('[Supplier Other Creditor] Load Complete', props<{ payload: SupplierOtherCreditor[] }>());
